import { API_BASE_URL } from "./constants/Constants";

const CONFIG_CACHE_KEY = 'runtimeConfig';

export const loadRuntimeConfig = async () => {
  // The config must never be left anywhere a user can read or edit it, so it is
  // deliberately NOT cached in sessionStorage/localStorage. Drop any copy left
  // behind by an older build.
  try { sessionStorage.removeItem(CONFIG_CACHE_KEY); } catch (e) { /* ignore */ }

  // Normal path: env-config.js (the <script> in index.html) has already
  // populated window._env_. sealEnv() in index.jsx copies it into a private
  // frozen object and removes it from window immediately after this resolves.
  if (window._env_ && Object.keys(window._env_).length > 0) {
    return;
  }

  // Fallback: fetch from the API.
  const baseUrl = API_BASE_URL;
  const configUrl = baseUrl + "api/config";

  try {
    const response = await fetch(configUrl);
    if (!response.ok) {
      throw new Error(`Config server returned ${response.status}`);
    }
    window._env_ = await response.json();
  } catch (error) {
    console.error(
      "CRITICAL: Could not load runtime config. App will not function.",
      error
    );
    window._env_ = {};
  }
};
